import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createNumberArraySchema } from '../../../lib/utils/validations/int-array-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledRadioInput from '../../elements/inputs/controlled-radio-input'
import ValidationButtons from '../../elements/validation-buttons'

type UpdateStatusInput = {
  journeyIds: number[]
  status: 'publish' | 'unpublish'
}

type Props = BaseFormProps<UpdateStatusInput, true> & {
  className?: string
}

const formSchema: ZodType<UpdateStatusInput> = z.object({
  journeyIds: createNumberArraySchema('voyages'),
  status: z.enum(['publish', 'unpublish'], {
    required_error: 'Veuillez sélectionner une option',
    message: 'Veuillez sélectionner une option'
  })
})

export const JourneyUpdateStatusForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: Props) => {
  const form = useForm<UpdateStatusInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
        className={'flex flex-col gap-3'}
      >
        <div className={cn('flex flex-col gap-5', className)}>
          <Typography variant={'label-medium'}>
            Veuillez sélectionner une action pour les séjours sélectionnés : publier ou dépublier.
            Ces actions affecteront la visibilité des séjours sur le site internet.
          </Typography>

          <div className={'flex flex-col gap-4'}>
            <FormField
              control={form.control}
              name={'status'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Publier les séjours'}
                      checked={field.value === 'publish'}
                      onCheck={() => field.onChange('publish')}
                    />
                  </FormControl>
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name={'status'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Dépublier les séjours'}
                      checked={field.value === 'unpublish'}
                      onCheck={() => field.onChange('unpublish')}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}
